<template>
  <v-card>
    <v-card-title class="position-relative">
      {{ $t('disconnectUser') }}

      <div class="close-dialog-btn">
        <v-btn
          icon
          color="primary"
          @click="$emit('close-disconnect-user-dialog')"
          class="close-button"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="mt-5">
      <form
        @submit.prevent="submit"
        class="d-flex flex-column mt-auto my-auto form"
        novalidate
        autocomplete="off"
      >
        <v-text-field
          :label="$t('programCode')"
          outlined
          class="flex-grow-0 mb-2"
          dense
          type="email"
          v-model="roomName"
          color="primary"
          :error-messages="roomNameErrors"
        ></v-text-field>

        <v-select
          v-model="userRole"
          :items="items"
          :label="$t('userRole')"
          dense
          outlined
          :error-messages="userRoleErrors"
        ></v-select>

        <v-btn
          color="primary"
          class="align-self-center"
          depressed
          type="submit"
          :loading="loader"
          :lang="$i18n.locale"
        >
          {{ $t('disconnectUser') }}
        </v-btn>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapMutations } from "vuex";
  import { required } from "vuelidate/lib/validators";
  import axios from "axios";

  export default {
    data() {
      return {
        roomName: "",
        loader: false,
        items: ['guide', 'school'],
        userRole: null
      };
    },
    validations: {
      roomName: { required },
      userRole: { required }
    },
    computed: {
      roomNameErrors() {
        const errors = [];
        if (!this.$v.roomName.$dirty) return errors;
        if (!this.$v.roomName.required)
          errors.push(this.$t('fieldRequired'));
        return errors;
      },
      userRoleErrors() {
        const errors = [];
        if (!this.$v.userRole.$dirty) return errors;
        if (!this.$v.userRole.required)
          errors.push(this.$t('fieldRequired'));
        return errors;
      }
    },
    methods: {
      ...mapMutations(["toggleSnackbar"]),
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        console.log(this.roomName);
        console.log(this.userRole);

        let payload = {
          programCode: this.roomName,
          role: this.userRole
        }

        try {
          this.loader = true;
          const res = await axios.post(`${process.env.VUE_APP_BASE_URL}/twilio/disconnectRole`, payload);
          console.log(res.data)
          this.loader = false;
          this.toggleSnackbar({
            open: true,
            text: 'User disconnected',
            color: "success",
          });
        } catch (e) {
          console.log(e)
          this.toggleSnackbar({
            open: true,
            text: 'User is not connected',
            color: "error",
          });
          this.loader = false;
        }
        // reset state
        this.roomName = '';
        this.userRole = null;
        this.$v.$reset();
        this.$emit('close-disconnect-user-dialog');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .logo {
    height: 30px;
    cursor: pointer;
  }

  .form {
    width: 400px;
  }

  .close-dialog-btn {
    position: absolute;
    right: 20px;
    top: 14px;
  }
</style>
